import { Component, EventEmitter, Input, Output } from "@angular/core";
import { SessionCell } from "../../../../../models/session-cell.model";

@Component({
  selector: 'app-session-scheduler-day',
  templateUrl: './session-scheduler-day.component.html',
  styleUrls: ['./session-scheduler-day.component.css']
})
export class SessionSchedulerDayComponent {
  @Input() session: SessionCell;
  @Output() onDaySelect = new EventEmitter<SessionCell>()

  constructor() {
  }

  onDaySelected() {
    this.onDaySelect.emit(this.session)
  }
}
